define(['jquery'], function ($) {
    'use strict';

    $().ready(function(){

        // Track this with Emarsys
        var url = "/emarsys/scarabQueue/index/";


        $.ajax({
            url: url,
            dataType: 'json',
            type: 'post',
            success: function (data) {

                var email = (data.setEmail).trim();
                var cartData = new Array();

                $.each(data.cart, function (sku) {
                    var price = data.cart[sku]["price"];
                    var qty = data.cart[sku]["quantity"];
                    var newItem = {
                        item: sku, price: price, quantity: qty
                    };
                    cartData.push(newItem);
                });

                if (email.length > 0) {
                    ScarabQueue.push(['setEmail', email]);
                }
                ScarabQueue.push(["cart", cartData]);

                if (data.tags) {
                    $.each(data.tags, function (tag) {
                        ScarabQueue.push(data.tags[tag]);
                    });
                }

                ScarabQueue.push(["go"]);
            }
        });
    });
});
